import { defineMessages } from 'react-intl';

export default defineMessages({
  createReturn: {
    defaultMessage: 'Create Return',
    description: 'orderDetails.createReturn',
    id: 'BTuiQQ',
  },
  hasPendingReturnTooltip: {
    defaultMessage: 'Please finish creating the pending return before creating a new one',
    description:
      'Tooltip explaining that the create return button is disabled, because the user needs to finish creating the one they have already started',
    id: '/D0Bg8',
  },
  isUnshippedTooltip: {
    defaultMessage: 'Ship a shipment to create a return',
    description: 'Tooltip explaining that the create return button is disabled, because there are no shipped shipments on the order',
    id: 'qPq9m0',
  },
  createReturnTooltip: {
    defaultMessage: 'Create a return shipment for this order',
    description: 'Tooltip for the create return button',
    id: 'I9UjMf',
  },
});
